import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function IpswichBreadcrumb({ current }) {
  return (
    <nav className="bg-white border-b border-slate-200 py-3 px-4" data-testid="ipswich-breadcrumb">
      <div className="max-w-6xl mx-auto flex items-center gap-1.5 text-sm">
        <Link to="/" className="text-slate-500 hover:text-[#7ABC32] transition-colors">Home</Link>
        <ChevronRight className="w-3.5 h-3.5 text-slate-400" />
        <Link to="/ipswich" className="text-slate-500 hover:text-[#7ABC32] transition-colors">Ipswich Services</Link>
        <ChevronRight className="w-3.5 h-3.5 text-slate-400" />
        <span className="text-slate-800 font-medium">{current}</span>
      </div>
    </nav>
  );
}
